import {
    Icon,
  } from "antd";

const StepIcon = ({isSuccess}) => {
    return (
        <Icon className={"gx-mr-2 " + (isSuccess ? "gx-text-success" : "gx-text-danger")} type={isSuccess ? "check-circle" : "close-circle"} />
    )
}

export default StepIcon;